export default __webpack_public_path__ + "static/media/gangdonggu-seongnaedong-redevelopment-5.05b246f1.jpg";